import { parseCookie } from "./parseCookie";
import { ROLES, ENDPOINT } from "../config";

import fetchData from "../helpers/fetchData";

// should be done more securely, attacker can just set the cookie in the console and
// access protected routes (although he won't get the data)
export const isLoggedIn = () => !!parseCookie("jwt");

export const isAdminRole = authorities =>
  authorities.some(x => x === ROLES.ADMIN);

export const setUserId = id => (window.id = id);

export const getUserId = () => window.id;

export const getUserInfo = () => {
  return fetchData(ENDPOINT.GET_USER_INFO, {
    method: "GET"
  }).then(res => {
    if (!res.ok) throw new Error();
    return res.json();
  });
};
